import React, { useState } from 'react';
import OrderQuantityStats from './OrderQuantityStats';
import OrderAmountStats from './OrderAmountStats';
import UserStatusStats from './UserStatusStats';

const StatTab = () => {
  const [activeTab, setActiveTab] = useState('order-quantity');
  
  const statTabs = [
    {
      key: 'order-quantity',
      label: '訂單數量統計',
      component: <OrderQuantityStats />
    },
    {
      key: 'order-amount',
      label: '訂單金額統計',
      component: <OrderAmountStats />
    },
    {
      key: 'user-status',
      label: '用戶開通狀態統計',
      component: <UserStatusStats />
    }
  ];

  return (
    <div style={{ background: '#f7faf9', padding: 24, borderRadius: 16, marginTop: 24 }}>
      {/* 自定義選項卡按鈕 */}
      <div style={{ 
        display: 'flex', 
        width: '100%', 
        marginBottom: 16,
        borderBottom: '1px solid #f0f0f0'
      }}>
        {statTabs.map(tab => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={{
              flex: 1,
              padding: '12px 16px',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              borderBottom: activeTab === tab.key ? '2px solid #1890ff' : '2px solid transparent',
              color: activeTab === tab.key ? '#1890ff' : '#666',
              fontWeight: activeTab === tab.key ? 'bold' : 'normal',
              fontSize: '16px',
              textAlign: 'center'
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>
      
      {/* 內容區域 */}
      <div>
        {statTabs.find(tab => tab.key === activeTab)?.component}
      </div>
    </div>
  );
};

export default StatTab; 